define('modules/map/map_model',[
  'backbone',
  'session'
], function (Backbone, session) {
  'use strict';
  var Model = Backbone.Model.extend({

    parse: function (response) {
      response.url = session.get('apiBaseUrl') + '/' + response.url;
      return response;
    },

    url: function () {
      return session.get('apiUrl') + 'locations/' + session.get('location_id') + '/map';
    }
  });
  return Model;
});

